module.exports = __webpack_public_path__ + "assets/img/mecha-43252c8a.png";